import PropTypes from "prop-types"
import React from "react"

import Heading from "src/components/Heading"

import Address from "../../Billing/InvoicePrintView/Address"
import Footer from "./Footer"
import InvoicesTable from "./InvoicesTable"
import Summary from "./Summary"

const ContactInvoicesPrintView = ({
  invoices,
  contact,
  marina,
  summaryTotals,
  presentmentCurrency,
  startDate,
  endDate,
  statusFilters,
  selectionText,
}) => {
  return (
    <div
      data-testid="contact-invoices-print-view"
      className="hidden print:block"
    >
      <div className="mt-6 flex flex-col space-y-4">
        <div className="flex flex-row justify-between">
          <div className="flex flex-col space-y-4">
            <Heading.PageTitle>Billing Summary</Heading.PageTitle>
            <div data-testid="contact-address">
              <div className="font-bold">CUSTOMER</div>
              <Address
                {...contact}
                showEmail={Boolean(contact.email)}
                showPhone={Boolean(contact.displayPhone)}
              />
            </div>
            <div className="py-6">
              <Summary
                summaryTotals={summaryTotals}
                presentmentCurrency={presentmentCurrency}
              />
            </div>
          </div>
          <div className="flex flex-col space-y-4">
            {marina.logoUrl ? (
              <div className="flex w-[200px] justify-end">
                <img src={marina.logoUrl} alt={`${marina.name} logo`} />
              </div>
            ) : null}
            <div className="text-right" data-testid="marina-address">
              <Address
                {...marina.address}
                {...marina}
                showPhone={Boolean(marina.displayPhone)}
              />
            </div>
          </div>
        </div>
        <InvoicesTable
          invoices={invoices}
          presentmentCurrency={presentmentCurrency}
        />
        <Footer
          startDate={startDate}
          endDate={endDate}
          statusFilters={statusFilters}
          selectionText={selectionText}
        />
      </div>
    </div>
  )
}

ContactInvoicesPrintView.propTypes = {
  invoices: PropTypes.array.isRequired,
  contact: PropTypes.object.isRequired,
  marina: PropTypes.object.isRequired,
  summaryTotals: PropTypes.object.isRequired,
  presentmentCurrency: PropTypes.string.isRequired,
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  statusFilters: PropTypes.arrayOf(PropTypes.string),
  selectionText: PropTypes.string,
}

export default ContactInvoicesPrintView
